import { render, staticRenderFns } from "./EditUserRights.vue?vue&type=template&id=1afa5b16&"
import script from "./EditUserRights.vue?vue&type=script&lang=ts&"
export * from "./EditUserRights.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports